<script>
import data from '../../data/jurusan.json';
import Header from '../../components/header-fix';
import Breadcrumb from '../../components/bread-crumb-1.vue';
import JurusanGrid from '../../components/jurusan-grid';
import Footer from '../../components/footer';
import OffCanvasMobileMenu from '../../components/off-canvas-mobile-menu';

export default {
  components: {
    Header,
    Breadcrumb,
    JurusanGrid,
    Footer,
    OffCanvasMobileMenu,
  },
  data() {
    return {
      data,
      items: [
        {
          text: 'Home',
          to: '/',
        },
        {
          text: 'Jurusan',
          active: true,
        },
      ],
    };
  },
  metaInfo: {
    title: 'Web Sekolah Onklas - Galeri',
    htmlAttrs: {
      lang: 'en',
      amp: true,
    },
  },
};
</script>

<template>
  <div class="main-container">
    <Header />

    <Breadcrumb :items="items" title="Daftar Jurusan SMA Negeri Indonesia" />

    <!-- Projects section start -->
    <div class="page-wrapper section-space--inner--80">
      <div class="project-section">
        <div class="container">
          <div class="row section-space--bottom--40">
            <div class="col-lg-12">
              <img
                src="assets/img/projects/project-details.jpg"
                class="img-fluid"
                alt="image"
              />
            </div>
          </div>
          <div class="row">
            <div class="col-lg-12">
              <div class="project-item-wrapper">
                <div class="row">
                  <div
                    class="col-lg-4 col-sm-6 col-12 section-space--bottom--30"
                    v-for="project in data.data"
                    :key="project.id"
                  >
                    <JurusanGrid :project="project" />
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>

    <Footer bgFooter="dark-bg" />

    <OffCanvasMobileMenu :meta="dataMeta" />

    <!-- back to top start -->
    <back-to-top class="scroll-top" bottom="60px">
      <i class="ion-android-arrow-up"></i>
    </back-to-top>
    <!-- back to top end -->
  </div>
</template>
